import { BACKGROUND_HEIGHT, BACKGROUND_WIDTH } from '../../utils/normaliseBackgroundImage/constants';

import type { CustomBackgroundEntry } from './types';

/**
 * Was the picked image smaller than the size we store at, and so upscaled to reach it?
 *
 * Either axis is enough: a 1920x400 panorama is stretched vertically and will look just as soft as
 * an image that is small in both directions.
 *
 * True only when we actually know. A background saved before dimensions were recorded, or one whose
 * pair failed the read-path repair, is never called low resolution — the stored copy has already
 * been upscaled and the original is gone, so there is no honest answer and the notice stays quiet.
 * Deliberately not inferred from the stored image: that is always the target size, so it would
 * report every older background as adequate, which is a confident wrong answer.
 */
export const isLowResolutionBackground = (background?: Pick<CustomBackgroundEntry, 'sourceWidth' | 'sourceHeight'>) =>
  !!background?.sourceWidth &&
  !!background.sourceHeight &&
  (background.sourceWidth < BACKGROUND_WIDTH || background.sourceHeight < BACKGROUND_HEIGHT);
